<!--仓库管理 - 领料单列表 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="部门：">
            <el-select size="medium" filterable v-model="searchForm.DEPARTMENT" placeholder="请选择" clearable>
              <el-option v-for="item in departmentList" :key="item.ID" :label="item.DEPARTMENT_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="领料人：">
            <el-input size="medium" v-model="searchForm.REQUISITIONER" placeholder="请输入领料人姓名" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input size="medium" v-model="searchForm.name" @keyup.enter.native="querySearch()" clearable></el-input>
          </el-form-item>
          <el-form-item label="领料日期：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="操作日期：">
            <el-date-picker size="medium" v-model="searchForm.OPERATION_DATE" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="querySearch()">筛选</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportPickingDoc">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-button size="medium" class="btn" type="primary" @click="gotoPickingProduct">领料出库</el-button>
        <el-button size="medium" class="btn" type="primary" @click="gotoDepartmentManage">领料部门管理</el-button>
      </el-col>
      <el-col>
        <el-table :data="tableData" border stripe style="margin-top: 20px;">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="ID" label="领料单ID"></el-table-column>
          <el-table-column prop="DEPARTMENT_NAME" label="部门"></el-table-column>
          <el-table-column prop="REQUISITIONER" label="领料人"></el-table-column>
          <el-table-column prop="CREATE_NAME" label="创建人"></el-table-column>
          <el-table-column prop="SEND_DAY" label="领料时间"></el-table-column>
          <el-table-column prop="TOTAL_FEE" label="领料总金额"></el-table-column>
          <el-table-column prop="CREATE_TIME" label="创建时间"></el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button type="text" @click="openDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount" style="float: right"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getDocFun, exportPickingDocFun } from 'api/pickingManage';
import { queryDepartment } from 'api/systemSetting';

export default {
  data() {
    return {
      tableData: [],
      searchForm: {},
      departmentList: [],
      pickerOptions: [],
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 20;
    if (JSON.stringify(this.PICKING_DOC_LIST) != '{}' && this.PICKING_DOC_LIST != undefined) {
      this.searchForm = this.PICKING_DOC_LIST.CONDITION;
      this.currentPage = this.PICKING_DOC_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.queryDepartment();
  },
  computed: {
    PICKING_DOC_LIST() {
      return this.$store.state.SAVE_PICKING_DOC;
    },
  },
  methods: {
    querySearch() {
      this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      if (this.searchForm.DEPARTMENT) {
        params.DEPARTMENT_ID = this.searchForm.DEPARTMENT;
      }
      if (this.searchForm.REQUISITIONER) {
        params.REQUISITIONER = this.searchForm.REQUISITIONER;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.OPERATION_DATE) {
        params.START_OPERATION_TIME = this.searchForm.OPERATION_DATE[0];
        params.END_OPERATION_TIME = this.searchForm.OPERATION_DATE[1];
      }
      getDocFun(params).then((res) => {
        if (res[0]) {
          this.tableData = res[0].list;
          this.totalCount = res[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SAVE_PICKING_DOC', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openDetail(row) {
      this.$router.push({ path: '/pickingDocDetail/detail' });
      sessionStorage.setItem('orderID', row.ID);
      sessionStorage.setItem('titleData', JSON.stringify(row));
    },
    // 拉取部门
    queryDepartment() {
      const params = {
        STATUS: 1,
      };
      queryDepartment(params).then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    exportPickingDoc() {
      const params = {};
      if (this.searchForm.DEPARTMENT) {
        params.DEPARTMENT_ID = this.searchForm.DEPARTMENT;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.OPERATION_DATE) {
        params.START_OPERATION_TIME = this.searchForm.OPERATION_DATE[0];
        params.END_OPERATION_TIME = this.searchForm.OPERATION_DATE[1];
      }
      exportPickingDocFun(params).then((res) => {
        window.location.href = res[0].FILE_PATH;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 领料出库
    gotoPickingProduct() {
      this.$router.push({ path: '/pickingProduct' });
    },
    // 领料部门管理
    gotoDepartmentManage() {
      this.$router.push({ path: '/departmentManage' });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/warehouseManage/pickingDoc.vue